// extracted by mini-css-extract-plugin
export var box = "_90-1";
export var checked = "_90-2";
export var descriptionSpacer = "_90-9";
export var disabled = "_90-3";
export var icon = "_90-6";
export var input = "_90-0";
export var labelSpacer = "_90-8";
export var medium = "_90-5";
export var small = "_90-4";
export var text = "_90-7";